module.exports = __webpack_public_path__ + "static/media/select-tabs-shift.d6ab83d5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FAQ/assets/select-tabs-shift.gif
// module id = 923
// module chunks = 0